import { useQuery } from 'react-query'; 
import axiosInstance from './axiosInstance';

const fetchUsersStats = async () => {
  const response = await axiosInstance.get('/super-admin/dashboard/analytics');
  return response.data;
};

export const useGetUsersStats = () => {
  return useQuery('users-stats', fetchUsersStats); 
};
